import { getExportHistory } from '@/services/call-log-service/call-log-service';
import { ReactQueryKeys } from '@/utils/react-query-keys';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useWebsocket } from '../use-websocket/use-websocket';
import {
  ExportHistory,
  ExportHistoryResponse,
} from '@/services/call-log-service/call-log-service.types';

interface useExportHistoryProps {
  page: number;
  items_per_page: number;
}

export const useExportHistory = ({ page, items_per_page }: useExportHistoryProps) => {
  const queryClient = useQueryClient();

  const {
    data: callLogExportHistoryData,
    error,
    isPending,
    refetch,
  } = useQuery({
    queryKey: ReactQueryKeys.EXPORT_HISTORY({ items_per_page, page }),
    queryFn: () => getExportHistory({ items_per_page, page }),
    staleTime: Infinity,
  });

  useWebsocket<{ report: ExportHistoryResponse }>({ channel: 'ReportChannel' }, ({ report }) => {
    if (!report) return;

    queryClient.setQueryData(
      ReactQueryKeys.EXPORT_HISTORY({ items_per_page, page }),
      (oldData: ExportHistory | undefined) => {
        if (!oldData) return oldData;

        return {
          ...oldData,
          reports: oldData.reports.map((item) =>
            item.id === report.id ? { ...item, ...report } : item
          ),
        };
      }
    );
  });

  return { callLogExportHistoryData, error, isPending, refetch };
};
